<template>
  <div id="pageContent">
    404
  </div>
</template>

<script>

export default {
  name: 'FindId',
  data() {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
